import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_BANNERS_ERROR, GET_BANNERS_START, GET_BANNERS_SUCCESS } from '../../types';

import apiCall from '../../../api/apiGet';

export function* get({ payload }) {
  try {
    const url = payload.lang ? `/banners/${payload.lang}` : '/banners/';
    const method = 'GET';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: GET_BANNERS_SUCCESS, results: results.data });

  } catch (error) {
    console.log(error)
    yield put({ type: GET_BANNERS_ERROR, error });
  }
}

export default function* get_banners() {
  yield takeLatest(GET_BANNERS_START, get);
}
